// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2cZzd","calendarButtons":"ClockData_calendarButtons__tS0Qq"};